var map = {
	"./01_icon.svg": "58d7",
	"./05_icon.svg": "10fe",
	"./07_icon.svg": "90ae",
	"./10_icon.svg": "5beb",
	"./13_icon.svg": "0b34",
	"./18_icon.svg": "6e43",
	"./19_icon.svg": "7ed7",
	"./20_icon.svg": "04d8",
	"./21_icon.svg": "7036",
	"./30_icon.svg": "7711",
	"./60_icon.svg": "8d7d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d92d";